<div class="ex-preview" data-source="scoped_example" role="region" [attr.aria-label]="copy.exampleLabel">
  <div class="ex-preview-your">
    <p class="ex-preview-kicker">{{ copy.yourDataTitle }}</p>
    <p class="ex-preview-your-body">{{ yourDataBody }}</p>
  </div>

  <div class="ex-preview-example">
    <div class="ex-preview-example-head">
      <span class="ex-preview-chip">{{ copy.exampleLabel }}</span>
      <span class="ex-preview-readonly">Read-only</span>
    </div>
    <p class="ex-preview-example-lead">{{ exampleLead }}</p>

    <div class="ex-preview-hours" *ngIf="variant === 'hours'">
      <div class="ex-preview-hours-meta">
        <strong>{{ workday.employeeName }}</strong>
        <span>{{ workday.employeeRole }} · {{ workday.dateLabel }}</span>
      </div>
      <ul class="ex-preview-hours-grid">
        <li *ngFor="let row of workday.hours">
          <em>{{ row.label }}</em>
          <strong>{{ row.value }}</strong>
        </li>
      </ul>
    </div>

    <div class="ex-preview-apps" *ngIf="variant === 'apps'">
      <div class="ex-preview-hours-meta">
        <strong>{{ workday.employeeName }}</strong>
        <span>{{ workday.employeeRole }} · {{ workday.dateLabel }}</span>
      </div>
      <div class="ex-preview-apps-cols">
        <div>
          <p class="ex-preview-col-title">Apps</p>
          <ul>
            <li *ngFor="let row of workday.apps">
              <strong>{{ row.name }}</strong>
              <em>{{ row.duration }}</em>
              <span>App</span>
            </li>
          </ul>
        </div>
        <div>
          <p class="ex-preview-col-title">Websites</p>
          <ul>
            <li *ngFor="let row of workday.websites">
              <strong>{{ row.name }}</strong>
              <em>{{ row.duration }}</em>
              <span>Website</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <app-what-you-control *ngIf="showControlCard" [compact]="true"></app-what-you-control>

  <div class="ex-preview-cta" *ngIf="showTryCta">
    <button type="button" class="ex-preview-cta-btn" (click)="onTryOneEmployee()">
      {{ copy.tryOneEmployee }}
      <mat-icon aria-hidden="true">arrow_forward</mat-icon>
    </button>
    <p>{{ copy.tryOneEmployeeSupport }}</p>
  </div>
</div>
